import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const GoogleAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    // Verifica que gtag está disponible
    if (typeof window.gtag === 'function') {
      // Envía el evento de vista de página a Google Analytics
      window.gtag('event', 'page_view', {
        page_path: location.pathname + location.search + location.hash,
        page_title: document.title,
        page_location: window.location.href
      });
    }
  }, [location]);

  // Este componente no renderiza nada
  return null;
};

export default GoogleAnalytics;